import React, { useRef } from 'react'
import { useState, useEffect } from 'react';
import { Modal, Input, AutoComplete, Select, Progress } from 'antd';
import {
  SubHeading,
} from "components/Typography";
import { FilePdfOutlined } from '@ant-design/icons';
import { DeleteFilled } from '@ant-design/icons';
import {
  updatepdf, setCheckedVideo, setCheckedQuestion, setCheckedLecture, fetchAdminChapterFilter, fetchClasslist,
  setUploadContent, updateStdList, fetchFilterTopic, updateSetType, fetchLibraryData, setKey, postCreateTopic, uploadCompleted2,
  uploadBlock2, uploadVideoMP4, MergeChunk, fileKeyUpdate, updateAdminChapterInfo, updateFilterTopic, subjectFilter
} from 'actions/digitalLibrary'
import { connect } from 'react-redux'
import UploadPdf from '../components/UploadPdf';
import { uploadlecturenotes } from 'actions/digitalLibrary';
import { v4 as uuidv4 } from "uuid";
import { PDFDocument } from 'pdf-lib';
import { Button } from 'components/Button';
import { Notification } from 'services';
import { uploadFileInChunks } from 'services/chunkedUpload';
// 10MB per block for /admin-library/UploadChunk. Other endpoints keep the
// service default, so this stays local to this upload.
const ADMIN_LIBRARY_CHUNK_SIZE = 1048576 * 10;
const blockUploadUrl = "http://fa43-2409-4065-e08-d929-c8c3-8cf8-cffc-39e7.ngrok.io/api/admin-library/UploadChunk";
const uploadCompleteUrl = "http://fa43-2409-4065-e08-d929-c8c3-8cf8-cffc-39e7.ngrok.io/admin-library/UploadComplete";

// Ids reach this modal in several shapes - subjects_id, subjectId, an AutoComplete
// option's id - and some of those arrive as strings. The /admin-library/content and
// UploadComplete DTOs validate them with @IsNumber, so normalise here rather than
// leaving a string to be rejected server-side. Anything unparseable becomes null,
// which the PUBLISH guard already treats as "not chosen".
const toId = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

function Uploadfiles({
  type, uploadlecturenotes,
  ismodelvisible,
  setmodevisible, setmodel,
  Pdftoupload, updatepdf, subjects,
  selectedStd, selectedSubject,
  setCheckedQuestion, setCheckedVideo, setCheckedLecture,
  getChaptersList, fetchAdminChapterFilter, fetchClasslist,
  getStdList, setUploadContent, updateStdList, fetchFilterTopic, topicList, tooglePageLoader,
  updateSetType, fetchLibraryData, setKey, setTabKey, contentPage, selectedChapter, selectedTopic,
  postCreateTopic, uploadCompleted2, uploadBlock2, uploadVideoMP4, fileKey, MergeChunk, fileKeyUpdate,
  updateAdminChapterInfo, classSubjectList, location, subjectFilter
}) {


  const [subjectname, setSubjectName] = useState(null)
  const [inputvalue, setinputvalue] = useState('')
  const [chaptersarray, setchapterarray] = useState([...getChaptersList])
  const [pdf, setpdf] = useState(null)
  const [chapter, setchapter] = useState('')
  const [classid, setclassid] = useState(null)
  const [subjectid, setsubjectid] = useState(null)
  const [chapterid, setchapterid] = useState(null)
  const [options, setOptions] = useState([]);
  const [submitLoader, setSubmitLoader] = useState(false)
  const [searchChapter, setSearchChapter] = useState("")
  const [optionsChapter, setOptionsChapter] = useState([]);
  const [chapterLoader, setChapterLoader] = useState(false)
  const [subjectLoder, setSubjectLoader] = useState(false)
  const [className, setClassName] = useState(null)
  const [topicId, setTopicId] = useState(null)
  const [topicName, setTopicName] = useState(null)
  const [classLoader, setClassLoader] = useState(false)
  const [topicLoader, setTopicLoader] = useState(false)
  let [topicListToShow, setTopicListToShow] = useState([])
  const [createLoader, setCreateLoader] = useState(false)
  // const inputFile = useRef(null);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [selectedFileSize, setSelectedFileSize] = useState(0);
  const [progress, setProgress] = useState(0);
  const [progressCheck, setProgressCheck] = useState(false)
  const [optionsBatch, setOptionsBatch] = useState([]);
  const [optionsTopic, setOptionsTopic] = useState([]);
  const [documentPages, setDocumentPages] = useState(0)
  // Each chunked upload attempt takes a token. Progress callbacks and the merge
  // only act while their token is still the live one, so an attempt the user has
  // moved past - one that failed and was retried, a cancel, a closed modal - can
  // never write to the bar or merge behind the attempt that replaced it.
  const uploadRunRef = useRef(0);
  let fileId = null;

  const inputchanged = (e) => {
    setinputvalue(e.target.value)
  }

  const searchResult = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || item.subjects_name || item.subjectname || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id || item.subjects_id || item.subjectId,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name
      };
    });

  const searchResultBatch = (query, currentValue) =>
    query.map((item, index) => {
      const displayValue = String(`${item.std} - ${item.section}`).trim();
      const isSelected = displayValue === String(currentValue || '').trim();
      return {
        key: index,
        value: displayValue,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: displayValue,
        displayValue: displayValue
      };
    });

  const searchResultTopic = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name,
        displayValue: name
      };
    });


  useEffect(() => {
    fileKeyUpdate('')
    subjectFilter('')
  }, [])

  // Retire whatever is still in flight when the modal goes away.
  useEffect(() => () => {
    uploadRunRef.current += 1;
  }, [])

  // The backend requires documentPages for pdf-backed content types (lecture-notes /
  // question-bank) - without it the /admin-library/content POST is rejected with
  // "documentPages is required for lecture-notes type" (surfaced on uat.aulas.ai;
  // some deployments were lenient about a missing/undefined value here, which is why
  // this went unnoticed). Read the page count off the selected PDF so it's always sent.
  useEffect(() => {
    if (!Pdftoupload || type === 'video') {
      setDocumentPages(0)
      return
    }
    const reader = new FileReader()
    reader.onload = async (e) => {
      try {
        const pdfDoc = await PDFDocument.load(e.target.result)
        setDocumentPages(pdfDoc.getPageCount())
      } catch (err) {
        console.error('Error reading PDF page count', err)
        setDocumentPages(0)
      }
    }
    reader.readAsArrayBuffer(Pdftoupload)
  }, [Pdftoupload, type])



  if (location === "subject")
    useEffect(() => {
      console.log("if triggered", classSubjectList);
      setOptions(classSubjectList ? [...searchResult(classSubjectList, subjectname)] : []);
    }, [classSubjectList, subjectname])
  else
    useEffect(() => {
      console.log("else triggered", subjects);
      setOptions(subjects ? [...searchResult(subjects, subjectname)] : [])
    }, [subjects, subjectname])

  useEffect(() => {
    setOptionsChapter(getChaptersList ? [...searchResult(getChaptersList, searchChapter)] : []);
  }, [getChaptersList, searchChapter])

  useEffect(() => {
    setOptionsBatch(getStdList ? [...searchResultBatch(getStdList, className)] : []);
  }, [getStdList, className])

  useEffect(() => {
    let opts = topicListToShow ? [...searchResultTopic(topicListToShow, topicName)] : [];
    if (topicName && opts.length === 0) {
      opts.push({
        value: -1,
        label: <div>Create {topicName}</div>,
        displayValue: topicName
      });
    }
    setOptionsTopic(opts);
  }, [topicListToShow, topicName])

  useEffect(() => {
    if (selectedSubject && Object.keys(selectedSubject).length !== 0) {
      setsubjectid(toId(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject.subjectId))
      setSubjectName(selectedSubject.subjects_name ? selectedSubject.subjects_name : selectedSubject?.subjectname)
      console.log("AA_selectedSubject", selectedSubject);
      fetchClasslist(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject.subjectId, '')
    }
    if (selectedStd && Object.keys(selectedStd).length !== 0) {
      setclassid(selectedStd.std_id ? selectedStd.std_id : selectedStd.classid)
      setClassName(selectedStd.standard ? selectedStd.standard + '-' + selectedStd.std_section : selectedStd?.className)
      // setclassid(selectedStd.std_id)
      // setClassName(selectedStd.standard + '-' + selectedStd.std_section)
    }

    if (selectedChapter && Object.keys(selectedChapter).length != 0) {
      // setchapterid(selectedChapter.chapterId)
      setchapterid(selectedChapter.chapterId ? selectedChapter.chapterId : selectedChapter?.chapterid)

      setchapter(selectedChapter.chapterName)
      setSearchChapter(selectedChapter.chapterName)
    }

    if (selectedTopic && Object.keys(selectedTopic).length != 0) {
      setTopicId(selectedTopic.topicId)
      setTopicName(selectedTopic.topicName)

    }

    // if (topicList?.length != 0) {
    //   setTopicListToShow([...topicList])
    // }
  }, [])

  useEffect(() => {
    if (topicList?.length != 0) {
      setTopicListToShow(topicList)
    }
    else {
      setTopicListToShow([])
    }
  }, [topicList])

  const handleSearch = (value) => {
    if (!value) {
      setSubjectName('')
      setsubjectid(null)
    }
    else {
      setSubjectName(value)
      setSubjectLoader(true)
    }
    subjectFilter(value, () => setSubjectLoader(false))
  };

  const handleChangeSub = (value, obj) => {
    console.log("changed", value)
    setsubjectid(null)
    setclassid(null)
    setClassName(null)
    setchapterid(null)
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateStdList([])
    if (value) {
      setSubjectName(obj?.label?.props?.children?.props?.children)
    }
    subjectFilter(value, () => { })
  }

  const handleSearchChapter = (value) => {
    setTopicId(null)
    setTopicName(null)
    if (!value) {
      setSearchChapter('')
    }
    else {
      setSearchChapter(value)
      setChapterLoader(true)
    }
    fetchAdminChapterFilter(value, classid, subjectid, () => setChapterLoader(false))

  };

  const handleSearchBatch = (value) => {
    setClassName(value)
    if (!value) {
      setclassid(null)
    }
  }

  const onSelectBatch = (value, obj) => {
    setclassid(obj.id)
    setClassName(value)
    if (obj.id != classid) {
      setChapterLoader(true)
      updateAdminChapterInfo([])
      setchapterid(null)
      setchapter('')
      setSearchChapter('')
      setTopicId(null)
      setTopicName(null)
      updateFilterTopic([])
      fetchAdminChapterFilter('', obj.id, subjectid, () => setChapterLoader(false))
      setchapterarray([...getChaptersList])
    }
  }

  const onSelect = (value, obj) => {
    setSubjectName(value)
    setsubjectid(toId(obj.id))
    fetchClasslist(obj.id, '')
    setclassid(null)
    setClassName(null)
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    updateStdList([])
    updateAdminChapterInfo([])
  }


  const onSelectChapter = (value, obj) => {
    updateFilterTopic([])
    setTopicId(null)
    setTopicName(null)
    setSearchChapter(value)
    setchapter(value)
    setchapterid(obj.id)
    setTopicLoader(true)
    fetchFilterTopic(subjectid, classid, obj.id, () => setTopicLoader(false))
  };

  const handleChangeChapter = (value, obj) => {
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateFilterTopic([])
    if (value) {
      setSearchChapter(value)
      setchapter(value)
    }
  }

  const onSelectTopic = (value, obj) => {
    if (value != -1) {
      setTopicId(obj.id)
      setTopicName(value)
    }
    else if (value == -1) {
      let object = {
        chapterId: chapterid,
        topicName: obj.displayValue
      }
      setTopicName(null)
      postCreateTopic(object, () => setCreateLoader(false), successCallbackTopic)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
  }

  const successCallbackTopic = () => {
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const handleChangeTopic = (value, obj) => {
    // console.log(value, obj)
    if (value != -1) {
      setTopicId(value)
      setTopicName(obj?.children)
    }
    else if (value == -1) {
      setTopicName(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const handleSearchTopic = (value) => {
    // console.log(value)

    if (value && value.trim() != '') {
      setTopicName(value)
      let topic;
      topic = topicList.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
      setTopicListToShow(topic)
      setTopicId(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
      setTopicListToShow(topicList)
    }
  }



  // console.log(Pdftoupload)

  const uploadFunction = async (callback, successCallback) => {
    const runId = uploadRunRef.current + 1;
    uploadRunRef.current = runId;
    const isCancelled = () => uploadRunRef.current !== runId;

    const currentFileId = uuidv4() + "." + Pdftoupload.name.split('.').pop();
    fileId = currentFileId;
    // The bar still holds the previous attempt's percentage; start this one at 0
    // rather than letting it appear to jump backwards from where the last ended.
    setProgress(0);
    try {
      await uploadFileInChunks({
        file: Pdftoupload,
        uploadChunk: (block, orderId, totalChunks) =>
          uploadBlock(block, orderId, totalChunks, currentFileId),
        // /admin-library/UploadChunk takes 10MB blocks; it is told the block
        // count up front (totalChunks) and merges once it has them all.
        chunkSize: ADMIN_LIBRARY_CHUNK_SIZE,
        onProgress: (percent) => {
          if (!isCancelled()) {
            setProgress(percent);
          }
        },
        isCancelled,
      });
      // Only merge once every block is up - uploadFileInChunks rejects otherwise.
      MergeChunk(currentFileId, callback, successCallback);
    } catch (error) {
      if (isCancelled()) {
        // Superseded or cancelled: the attempt that replaced this one owns the UI.
        return;
      }
      console.log("error in block upload", error);
      Notification.error("Error", "Upload failed. Please try again.");
      if (callback) {
        callback();
      }
    }
  };

  const uploadBlock = async (currentBlock, orderId, totalChunks, fileName) => {
    var params = {
      file: currentBlock,
      orderId: orderId,
      fileName: fileName || fileId,
      totalChunks: totalChunks
    }
    const response = await uploadBlock2(params, () => { });
    if (response?.data?.progress?.message !== "uploaded") {
      throw new Error(`Block ${orderId} was not accepted by the server`);
    }
  }

  const callbackChunk = () => {
    setSubmitLoader(false)
    setProgressCheck(false)
  }

  useEffect(() => {
    if (fileKey) {
      uploadCompleted(() => setSubmitLoader(false), successCallback)
    }
  }, [fileKey])

  const successCallbackMergeChunk = () => {
    if (fileKey) {
      uploadCompleted(() => setSubmitLoader(false), successCallback)
    }
  }

  const uploadCompleted = async (callback, successCallback) => {
    // console.log("upload completed api calling")
    var object = {
      subjectId: subjectid,
      chapterId: parseInt(chapterid),
      title: inputvalue,
      standardId: parseInt(classid),
      type,
      fileName: fileKey,
      chapterName: chapter,
      topicId: toId(topicId),
      videoFileSize: Pdftoupload?.size
    }
    uploadCompleted2(object, (response) => {
      // console.log(response)
      if (callback) {
        callback()
      }
      if (response != undefined) {
        if (response) {
          setProgress(100);
          if (successCallback) {
            successCallback()
          }
          // console.log("complete api successss");
        }
      }
      else {
        if (callback) {
          callback()
        }
      }
    })
  };

  const successhandler = () => {
    if (submitLoader) {
      // Already publishing. A second run would share this component's progress
      // state with the first and make the bar flip between the two.
      return;
    }
    console.log('subjectID', subjectid, chapterid, inputvalue, classid, chapter, topicId);
    if (Pdftoupload && subjectid && chapterid && inputvalue && classid && chapter, topicId) {
      var objectToUpload = {
        subjectId: subjectid,
        chapterId: parseInt(chapterid),
        title: inputvalue,
        standardId: parseInt(classid),
        type,
        file: Pdftoupload,
        chapterName: chapter,
        topicId: toId(topicId),
        // Required by the backend for lecture-notes/question-bank content - see the
        // documentPages useEffect above.
        ...(type !== 'video' && { documentPages }),
      }
      setProgressCheck(true)
      if (type == 'lecture-notes' && contentPage) {
        setTabKey('1')
        updateSetType(type);
      }
      else if (type == 'video' && contentPage) {
        setTabKey('2')
        updateSetType(type);
      }
      else if (type == 'question-bank' && contentPage) {
        setTabKey('3')
        updateSetType(type);
      }
      setSubmitLoader(true)
      if (type == 'video') {
        uploadFunction(callbackChunk, successCallbackMergeChunk)
      }
      else {
        uploadlecturenotes(objectToUpload, () => setSubmitLoader(false), successCallback, setProgress)
      }
      setpdf(null)
    }


    if (subjectid && chapterid && inputvalue && classid && chapter && subjectname && className && topicId) {
      var selectedUploadObject = {
        subjectId: subjectid,
        subjectname: subjectname,
        classid: parseInt(classid),
        className: className,
        chapterid: parseInt(chapterid),
        chapterName: chapter,
        topicId: parseInt(topicId),
        topicName: topicName,
        title: inputvalue
      }

      setUploadContent(selectedUploadObject)
    }
  }

  const successCallback = () => {
    updatepdf(null)
    setTopicListToShow([])
    setProgressCheck(false)
    fileKeyUpdate('')
    setmodevisible(false)
    setmodel(true)
  }

  const handleCancel = () => {
    // Anything still uploading belongs to a dialog the user just dismissed.
    uploadRunRef.current += 1;
    updatepdf(null)
    setchapterid(null)
    setOptions([])
    setSearchChapter('')
    setchapter('')
    setinputvalue('')
    fileKeyUpdate('')
    setProgressCheck(false)
    setTopicListToShow([])
    setCheckedVideo(false)
    setCheckedQuestion(false)
    setCheckedLecture(false)
    setmodevisible(false);
  };

  return (
    <Modal className='rounded-border' width='700px' visible={ismodelvisible} footer={null} closable={!progressCheck} onCancel={handleCancel} maskClosable={false}>

      <div className='lecturenotestitle' style={{ width: '100%', textAlign: 'center', padding: '0px' }}>
        <p style={{ margin: '0px' }}> Upload content for digital library</p>
      </div>
      <div className='lecturnotesdescription' style={{ padding: '0px', width: '100%', textAlign: 'center' }}>
        <p style={{ margin: '0px', marginBottom: '30px' }}> Kindly attach the file and fill in the informations below</p>
      </div>
      <div style={{ display: (progressCheck) ? 'inline' : 'none', marginBottom: '5px' }}>
        Uploading...
        <Progress type='line' style={{ width: '100%', display: progressCheck ? 'inline' : 'none' }} percent={progress} />
      </div>
      <div style={{ display: 'flex', height: '400px', justifyContent: 'space-between' }}>
        {
          !pdf ?
            <div style={{ width: '49%' }} >
              <div
                className='uploadfiles'
                style={{ width: "100%" }}
              >
                <UploadPdf type={type} progressCheck={progressCheck}></UploadPdf>
              </div>
            </div>
            :
            <div style={{ width: '49%' }} >
              <div className='uploadfiles'>
                <div style={{ marginTop: '45%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: '10%' }}>
                  <div><FilePdfOutlined style={{ color: 'red', width: '10%', height: '10%' }} /></div>
                  <p style={{ margin: '0px' }}>{pdf}</p>
                  <p style={{ margin: '0px' }}>2.50 MB</p>
                </div>
                <div style={{ marginTop: '20%', alignItems: 'center', display: !progressCheck ? 'flex' : 'none', flexDirection: 'row', justifyContent: 'center', height: '10%', width: '100%' }}>
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', paddingRight: '5px' }}>
                    <DeleteFilled onClick={() => setpdf(null)} style={{ color: '#AEAEAE' }} />
                  </div >
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                    <a style={{ paddingLeft: '5px', marginBottom: '0px', color: '#AEAEAE', font: 'normal normal normal 12px/26px Roboto', fontSize: '12px', opacity: '1' }} onClick={() => setpdf(null)}>Remove</a>
                  </div>
                </div>
              </div>
            </div>
        }
        <div className='uploadsearchbox' style={{ width: '49%' }}>
          <div className='full-width'>

            <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Subject <span style={{ color: "red" }}>*</span></p>
            <AutoComplete
              getPopupContainer={(trigger) => trigger.parentElement}
              allowClear={subjectname ? true : false}
              dropdownMatchSelectWidth={252}
              className='autocompletetoupload'
              options={options}
              value={subjectname}
              onSelect={onSelect}
              onSearch={handleSearch}
              onFocus={() => {
                setTimeout(() => {
                  subjectFilter('')
                }, 100)
              }}
              filterOption={false}
              onChange={handleChangeSub}
              loading={subjectLoder}
              disabled={progressCheck}
            >
              <Input size="middle"
                onClick={() => subjectFilter('')}
                style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }} placeholder="Search subject" />
            </AutoComplete>
          </div>
          <div className='udloadFilesDropdown' style={{ width: '100%' }}>
            <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Batch <span style={{ color: "red" }}>*</span></p>
            <AutoComplete
              getPopupContainer={(trigger) => trigger.parentElement}
              allowClear={className ? true : false}
              dropdownMatchSelectWidth={252}
              options={optionsBatch}
              value={className}
              onSelect={onSelectBatch}
              onSearch={handleSearchBatch}
              filterOption={false}
              className='autocompletetoupload'
              loading={classLoader}
              disabled={subjectid && !progressCheck ? false : true}
            >
              <Input size="middle"
                style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                placeholder="Select batch" />
            </AutoComplete>
          </div>


          <div style={{ width: '100%' }}>
            <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Chapter <span style={{ color: "red" }}>*</span></p>
            <div style={{ width: '100%' }}>
              <AutoComplete
                getPopupContainer={(trigger) => trigger.parentElement}
                allowClear={searchChapter ? true : false}
                dropdownMatchSelectWidth={252}
                disabled={classid && subjectid && !progressCheck ? false : true}
                className='autocompletetoupload'
                options={optionsChapter}
                value={searchChapter}
                onChange={handleChangeChapter}
                onSelect={onSelectChapter}
                onSearch={handleSearchChapter}
                loading={chapterLoader}
              >
                <Input size="middle" style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }} placeholder="Search Chapter" />
              </AutoComplete>
            </div>
          </div>


          <div className='generaltwocomponent udloadFilesDropdown' style={{ width: '100%' }}>
            <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Topic <span style={{ color: "red" }}>*</span></p>
            <AutoComplete
              getPopupContainer={(trigger) => trigger.parentElement}
              allowClear={topicName ? true : false}
              dropdownMatchSelectWidth={252}
              options={optionsTopic}
              value={topicName}
              onSelect={onSelectTopic}
              onSearch={handleSearchTopic}
              filterOption={false}
              className='autocompletetoupload'
              loading={topicLoader}
              disabled={chapterid && !progressCheck ? false : true}
            >
              <Input size="middle"
                style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                placeholder="Select Topic" />
            </AutoComplete>
          </div>
          <div className='generaltwocomponent' style={{ width: '100%' }}> <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Title <span style={{ color: "red" }}>*</span></p>
            <div className='uploadfilesinput'>
              <Input size='middle' bordered={false} onChange={inputchanged} value={inputvalue} placeholder='Enter title'
                style={{
                  background: '#FAFAFA 0% 0% no-repeat padding-box',
                  borderRadius: '4px', opacity: '1'
                }}
                disabled={progressCheck}
              >
              </Input>
            </div>
          </div>
        </div>
      </div>

      {/* <div style={{ display: (progressCheck) ? 'inline' : 'none' }}>
        Uploading...
        <Progress type='line' style={{ width: '100%', display: progressCheck ? 'inline' : 'none' }} percent={progress} />
      </div> */}

      <div style={{ width: '100%', marginTop: '3%' }}>
        <div style={{ width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <Button style={{ width: "122px", marginRight: "5px", }} type="default" onClick={handleCancel} disabled={progressCheck}>CANCEL</Button>
          <Button loading={submitLoader} style={{ marginLeft: "5px", width: '122px' }} type="primary" disabled={(Pdftoupload && subjectid && chapterid && inputvalue.trim() != '' && classid && chapter && topicId) ? false : true} onClick={successhandler}>PUBLISH</Button>
        </div>
      </div>

    </Modal>
  )

}

const mapStateToProps = (state) => {
  const {
    Pdftoupload,
    subjects,
    selectedStd,
    selectedSubject,
    checkedLecture,
    checkedVideo,
    checkedQuestion,
    getChaptersList,
    getStdList,
    topicList,
    selectedChapter,
    selectedTopic,
    fileKey,
    classSubjectList,

  } = state.digitalLibrary;
  return {
    Pdftoupload,
    subjects,
    selectedStd,
    selectedSubject,
    checkedLecture,
    checkedVideo,
    checkedQuestion,
    getChaptersList,
    getStdList,
    topicList,
    selectedChapter,
    selectedTopic,
    fileKey,
    classSubjectList
  };
};

const mapDispatchToProps = (dispatch) => ({
  updatepdf: (data) => dispatch(updatepdf(data)),
  subjectFilter: (data, callback) => dispatch(subjectFilter(data, callback)),
  uploadlecturenotes: (data, callback, successCallback, setProgress) => dispatch(uploadlecturenotes(data, callback, successCallback, setProgress)),
  setCheckedLecture: (bool) => dispatch(setCheckedLecture(bool)),
  setCheckedVideo: (bool) => dispatch(setCheckedVideo(bool)),
  setCheckedQuestion: (bool) => dispatch(setCheckedQuestion(bool)),
  fetchAdminChapterFilter: (value, classid, subjectid, callback) => dispatch(fetchAdminChapterFilter(value, classid, subjectid, callback)),
  fetchClasslist: (subid, chapterName, callback) => dispatch(fetchClasslist(subid, chapterName, callback)),
  setUploadContent: (obj) => dispatch(setUploadContent(obj)),
  updateStdList: (std) => dispatch(updateStdList(std)),
  fetchFilterTopic: (subId, stdId, chapterId, callback) => dispatch(fetchFilterTopic(subId, stdId, chapterId, callback)),
  updateSetType: (type) => dispatch(updateSetType(type)),
  fetchLibraryData: (search, callback) => dispatch(fetchLibraryData(search, callback)),
  setKey: (key) => dispatch(setKey(key)),
  postCreateTopic: (object, callback, successCallback) => dispatch(postCreateTopic(object, callback, successCallback)),
  uploadBlock2: (params, callback) => dispatch(uploadBlock2(params, callback)),
  uploadCompleted2: (object, callback) => dispatch(uploadCompleted2(object, callback)),
  uploadVideoMP4: (data) => dispatch(uploadVideoMP4(data)),
  MergeChunk: (fileId, callback, successCallback) => dispatch(MergeChunk(fileId, callback, successCallback)),
  fileKeyUpdate: (key) => dispatch(fileKeyUpdate(key)),
  updateAdminChapterInfo: (data) => dispatch(updateAdminChapterInfo(data)),
  updateFilterTopic: (data) => dispatch(updateFilterTopic(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps

)(Uploadfiles);